import React, { ChangeEvent, useState } from "react";
import { patchOrderBaristaByID } from "../../../api/order.api";

type Props = {
  reject?: number | null;
  rejectArray?: [];
  onClose: () => void;
};

const CancelOrder: React.FC<Props> = ({ rejectArray, reject, onClose }) => {
  const [isCheckTextField, setIsCheckTextField] = useState<boolean>(false);
  const [isNote, setIsNote] = useState<string>("");
  const [isCheck, setIsCheck] = useState<boolean>(false);
  const [isReasonInput, setReasonInput] = useState<boolean>(false);
  const [isTextReject, setIsTextReject] = useState<string>("");
  const handleClickTextField = () => {
    setIsCheck(true);
    if (!isCheckTextField) {
      setReasonInput(false);
    } else {
      setIsNote(isTextReject);
      setReasonInput(true);
    }
  };

  const handleValidateNote = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    if (inputValue === " ") {
      setReasonInput(false);
      setIsCheckTextField(false);
    } else if (inputValue.charAt(0) === " ") {
      event.preventDefault();
      setReasonInput(false);
      setIsCheckTextField(false);
    } else {
      setIsTextReject(inputValue);
      setIsNote(isTextReject);
      setReasonInput(true);
      setIsCheckTextField(true);
    }
  };

  const RadioBT = ({ rejection }: { rejection: string }) => {
    const handleRadioClick = () => {
      setIsCheck(false);
      setIsNote(rejection);
      setReasonInput(true);
    };
    return (
      <>
        <div className="w-full" onClick={handleRadioClick}>
          <div className="BT flex items-center font-nunito my-4">
            <input
              type="radio"
              name="reject_note"
              className="h-16 w-16 text-blue-600 bg-gray-100 border-gray-300 "
              value={rejection}
              checked={isNote === rejection}
            />
            <span className="ml-20 font-normal text-secondary-S600 text-14">
              {rejection}
            </span>
          </div>
        </div>
      </>
    );
  };

  const handleClose = () => {
    setIsCheck(false);
    setReasonInput(false);
    setIsNote("");
    onClose();
  };

  const handleClick = async () => {
    // @ts-ignore
    if (reject === null || rejectArray?.length < 1) {
      return;
      // @ts-ignore
    } else if (rejectArray?.length > 0) {
      rejectArray?.map(async (id) => {
        try {
          await patchOrderBaristaByID(id ?? 0, {
            reject_note: isNote,
            status: "rejected",
          });
          setIsCheck(false);
          setReasonInput(false);
          onClose();
        } catch (error) {
          console.error(error);
        }
      });
    } else {
      try {
        await patchOrderBaristaByID(reject ?? 0, {
          reject_note: isNote,
          status: "rejected",
        });
        setIsCheck(false);
        setReasonInput(false);
        onClose();
      } catch (error) {
        console.error(error);
      }
    }
  };
  // @ts-ignore
  if (reject === null || rejectArray?.length < 1) return null;
  return (
    <>
      <main className="RejectMenu bg-white font-nunito h-screen w-screen flex flex-col justify-between fixed top-0 left-0">
        <div className="flex flex-col items-center h-full w-full">
          <header className="h-48 w-full border-b-2 border-neutral-N40">
            <div className="Text flex flex-row items-center h-full w-full">
              <svg
                width="8"
                height="12"
                viewBox="0 0 8 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={handleClose}
                className="ml-20"
              >
                <path
                  d="M7.70492 1.41L6.29492 0L0.294922 6L6.29492 12L7.70492 10.59L3.12492 6L7.70492 1.41Z"
                  fill="black"
                />
              </svg>
              <div className="mr-[27px] w-full flex justify-center">
                <label className=" text-primary-onligth font-semibold text-18 ">
                  Cancel Order
                </label>
              </div>
            </div>
          </header>
          <body className=" w-full ">
            <section className="Reason w-full ">
              <div className="items-center justify-between ml-20 mt-16">
                <label className="font-normal text-secondary-S600 text-16 font-nunito">
                  Reason:
                </label>
                <span
                  className={`text-12 px-1  ${isReasonInput ? "text-gray-500" : "text-red-500"
                    } `}
                >
                  (Require)
                </span>
                <div className="ForButton flex flex-col items-start mt-4">
                  <RadioBT rejection={"Ingredient Unavailable"} />
                  <RadioBT rejection={"Barista was not at the bar"} />
                  <RadioBT rejection={"Machine Failure"} />
                  <RadioBT rejection={"Barista can not fine your tumbler"} />
                  <RadioBT rejection={"The shop is closing"} />

                  <div
                    className="BT flex w-full items-center  "
                    onClick={handleClickTextField}
                  >
                    <div className="flex items-center  ">
                      <input
                        type="radio"
                        name="reject_note"
                        className="h-16 w-16 text-blue-600 bg-gray-100 border-gray-300 "
                        checked={isCheck}
                      />
                    </div>

                    <div className="flex flex-row w-full items-center font-nunito ">
                      <label className="font-normal text-secondary-S600   text-14 ml-20 whitespace-nowrap">
                        Other
                      </label>
                      <input
                        type="text"
                        name="menuName"
                        maxLength={27}
                        placeholder="Write here"
                        onChange={handleValidateNote}
                        onKeyDown={(
                          event: React.KeyboardEvent<HTMLInputElement>
                        ) => {
                          if (event.target instanceof HTMLInputElement) {
                            const inputValue = event.target.value;
                            if (inputValue === "" && event.key === " ") {
                              event.preventDefault();
                            }
                          }
                        }}
                        className="mx-16 w-full h-32 inline-block rounded-md text-sm bg-netural-N20  font-normal text-black text-16 pl-12"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </body>
          <footer className="w-full my-16 ">
            <section className="Button px-[16px] pb-16 w-full flex flex-row text-16 font-nunito font-semibold">
              <button
                className="Button h-40 w-full flex items-center justify-center
                                    rounded-md text-center text-sm bg-netural-N40 text-secondary-S600"
                onClick={handleClose}
              >
                Close
              </button>
              <button
                className={`Button ml-[4px] h-40 w-full flex items-center justify-center   
            ${isReasonInput
                    ? "bg-primary-P500 hover:bg-primary-P300 text-white "
                    : "bg-netural-N40  text-netural-N80"
                  }
                                    rounded-md text-center text-sm`}
                onClick={handleClick}
                disabled={!isReasonInput}
              >
                Cancel this order
              </button>
            </section>
          </footer>
        </div>
      </main>
    </>
  );
};
export default CancelOrder;
